import { Injectable, Output, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PatientBannerService {
  @Output() patientBanner: EventEmitter<number> = new EventEmitter();
  @Output() patBanHide: EventEmitter<boolean> = new EventEmitter();
  @Output() videocallShow: EventEmitter<boolean> = new EventEmitter();
  @Output() videotoggelShow: EventEmitter<boolean> = new EventEmitter();
  @Output() loadAppointments: EventEmitter<boolean> = new EventEmitter();
  @Output() DialerPadShow: EventEmitter<boolean> = new EventEmitter();
  constructor() { }

  toggle(e: any) {
    this.patientBanner.emit(e);
  }

  hide(e: any) {
    this.patBanHide.emit(e);
  }

  videoCall(e: any) {
    this.videocallShow.emit(e);
  }

  toggleVideo(e: any) {
    this.videotoggelShow.emit(e);
  }
  getAppointments(e: any) {
    this.loadAppointments.emit(e);
  }
  DialerPad(e: any) {
    this.DialerPadShow.emit(e);
  }
}
